import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const ResetPasswordConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const username = location.state?.username || "User";

  useEffect(() => {
    // Auto-redirect to home/dashboard after 3 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="forget-password bg-light p-4 rounded text-center">
      <div
        className="verify-email-icon verify-email-icon-success mb-3"
        style={{ fontSize: "3rem", color: "#28a745" }}
      >
        ✓
      </div>
      <h2 className="text-success mb-3">Password Reset Successful</h2>
      <p>
        Hi <strong>{username}</strong>,
      </p>
      <p>
        Your password has been successfully updated. We are logging you in
        securely...
      </p>
      <Spinner animation="border" variant="success" className="mt-4" />
    </div>
  );
};

export default ResetPasswordConfirmation;